// Parses the Google redirect-back URL (Option A). The backend may hand the
// access token back in either the URL fragment (recommended — kept out of
// server logs/Referer) or a query param, and may name it `access_token` or
// `token`. We accept all of these so the frontend tolerates the backend's final
// choice. The fragment takes precedence when both carry the same key.
export type AuthCallbackResult = {
  accessToken?: string;
  error?: string;
};

const stripLeading = (value: string | undefined, char: string) =>
  value && value.startsWith(char) ? value.slice(1) : (value ?? '');

export function parseAuthCallback(location: { hash?: string; search?: string }): AuthCallbackResult {
  const fragment = stripLeading(location.hash, '#');
  const query = stripLeading(location.search, '?');

  // Merge both sources; fragment values win on key collisions.
  const params = new URLSearchParams();
  for (const source of [query, fragment]) {
    if (!source) continue;
    new URLSearchParams(source).forEach((value, key) => params.set(key, value));
  }

  return {
    accessToken: params.get('access_token') ?? params.get('token') ?? undefined,
    error: params.get('error') ?? undefined,
  };
}
